export const defaultSeo = {
  siteUrl: 'https://www.mh-beton.at',
  telephone: '+43 660 909 1992',
  email: 'office@mh-beton.at',
  address: {
    streetAddress: 'Hochwaldweg 2A/2/37',
    postalCode: '1220',
    addressLocality: 'Wien',
    addressCountry: 'AT',
  },
  areaServed: ['Wien', 'Wien Umgebung', 'Niederösterreich'],
};

export const businessSchema = {
  '@context': 'https://schema.org',
  '@type': 'LocalBusiness',
  name: 'MH-BETON',
  url: defaultSeo.siteUrl,
  image: `${defaultSeo.siteUrl}/assets/img/og-image.jpg`,
  telephone: defaultSeo.telephone,
  email: defaultSeo.email,
  address: {
    '@type': 'PostalAddress',
    ...defaultSeo.address,
  },
  areaServed: defaultSeo.areaServed,
  description: 'Betontransport, Betonverkauf und Betonpumpenvermietung mit Fahrer in Wien, Wien Umgebung und Niederösterreich.',
  hasOfferCatalog: {
    '@type': 'OfferCatalog',
    name: 'Betonleistungen',
    itemListElement: [
      {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'Betonpumpenvermietung mit Fahrer',
        },
      },
      {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'Betontransport',
        },
      },
      {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'Betonverkauf',
        },
      },
    ],
  },
};

export const homeFaqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: 'Welche Informationen braucht MH-BETON für ein Angebot?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Hilfreich sind Baustellenadresse, gewünschter Termin, Betonmenge in Kubikmetern, Einbringstelle, Zufahrtssituation und ob eine Betonpumpe mit Fahrer benötigt wird.',
      },
    },
    {
      '@type': 'Question',
      name: 'In welchem Gebiet ist MH-BETON im Einsatz?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'MH-BETON ist in Wien, Wien Umgebung und Niederösterreich für Betontransport, Betonverkauf und Betonpumpenvermietung tätig.',
      },
    },
    {
      '@type': 'Question',
      name: 'Kann ich direkt telefonisch anfragen?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Ja. Für schnelle Abstimmung ist MH-BETON telefonisch unter +43 660 909 1992 erreichbar.',
      },
    },
  ],
};

export const serviceSchema = (service) => ({
  '@context': 'https://schema.org',
  '@type': 'Service',
  name: service.title,
  provider: {
    '@type': 'LocalBusiness',
    name: 'MH-BETON',
    telephone: defaultSeo.telephone,
    email: defaultSeo.email,
    address: {
      '@type': 'PostalAddress',
      ...defaultSeo.address,
    },
    areaServed: defaultSeo.areaServed,
  },
  description: service.description,
  url: `${defaultSeo.siteUrl}/leistungen/${service.slug}`,
});
